module.exports = __webpack_public_path__ + "static/media/07.f17eeaf4.jpg";